import type { Category } from "@/hooks/use-categories"

/** Categories offered in a picker: hidden ones are dropped, except the currently selected one. */
export function pickableCategories<T extends Pick<Category, "id" | "hidden">>(
  cats: T[],
  selectedId?: string | null,
): T[] {
  return cats.filter((c) => !c.hidden || c.id === selectedId)
}
